import {TFunction} from "i18next";
import {ApplicationRole} from "./ApplicationRoles";
import {ApplicationFormatter} from "../applications/ApplicationProvider";
import {Application} from "../applications/Application";
import {KeycloakUser} from "./KeycloakUser";
import {MRT_ColumnDef} from "material-react-table";

export function keycloakUserTableCols(t: TFunction, applicationFormatter: ApplicationFormatter, applications: Application[]): MRT_ColumnDef<KeycloakUser>[] {
  return [
    { accessorKey: 'keycloakId', header: t('User.keycloakId'), enableColumnFilter: false, },
    { accessorKey: 'email', header: t('User.email'), enableColumnFilter: false, },
    { accessorKey: 'firstName', header: t('User.firstName'), enableColumnFilter: false },
    { accessorKey: 'lastName', header: t('User.lastName'), enableColumnFilter: false },
    {
      id: 'applicationRoles',
      header: t('Application.title') + "/" + t('User.role'),
      enableColumnFilter: true,
      accessorFn: (row: KeycloakUser) => row.applicationRoles.map(appRole => applicationFormatter.formatApplicationRole(appRole)).join(' / '),
      filterVariant: 'select',
      filterSelectOptions: applications.map(app => ({
        text: app.name,
        value: app.id
      })),
      filterFn: (row, columnId, filterValue) => {
        // console.info('row: ', row);
        // console.info('columnId: ' + columnId);
        // console.info('filterValue: ' + filterValue);
        const applicationRoles: ApplicationRole[] = row.original.applicationRoles;
        // console.info("Application Roles: " + JSON.stringify(applicationRoles))
        const result = applicationRoles?.find((applicationRole) => applicationRole?.application?.id === filterValue);
        // console.info('Result: ' + !!result);
        return !!result
      }
    },
  ] as MRT_ColumnDef<KeycloakUser>[];
}
